import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { useLogoutBroadcast } from "ls/composables/useLogoutBroadcast";
import { computed } from "vue";
import { queries } from "./queries";
import { useAccountService } from "./useAccountService";

export function useAuth() {
  const {
    user,
    isAuthenticated,
    error,
    login,
    logout: accountServiceLogout,
    updateUserProfileName,
    uploadUserProfileImg,
    deleteUserProfileImg,
    changeAccountInfo,
    forgotPassword,
  } = useAccountService();

  const queryClient = useQueryClient();

  const { postLogout } = useLogoutBroadcast();
  async function logout() {
    try {
      await accountServiceLogout();
    } finally {
      queryClient.clear();
      postLogout();
    }
  }

  return {
    user,
    isAuthenticated,
    error,
    login,
    logout,
    updateUserProfileName,
    uploadUserProfileImg,
    deleteUserProfileImg,
    changeAccountInfo,
    forgotPassword,
  };
}

export function useCurrentUserInfo() {
  const { user } = useAuth();
  const options = computed(() => {
    return {
      ...queries.info(),
      enabled: !!user.value,
    };
  });
  const { data: userInfo } = useQuery(options);
  return userInfo;
}
